import { render, staticRenderFns } from "./club-bet-optin-popup.vue?vue&type=template&id=510a8e1f&scoped=true&"
import script from "./club-bet-optin-popup.vue?vue&type=script&lang=js&"
export * from "./club-bet-optin-popup.vue?vue&type=script&lang=js&"
import style0 from "./club-bet-optin-popup.vue?vue&type=style&index=0&id=510a8e1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510a8e1f",
  null
  
)

export default component.exports